import { Product } from 'shared/types/product/Product';
import { Facet } from 'shared/types/result/Facet';
import ProductListProvider from 'components/gruenland/organisms/product-list/context';
import { ProductListProps } from 'components/gruenland/organisms/product-list/ProductList';
import { EditorialCategoryConfiguration, FacetConfiguration } from 'components/gruenland/organisms/product-list/types';
import { flattenTree } from 'helpers/utils/flattenTree';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import buildFacetsConfiguration from './buildFacetsConfiguration';
import ProductListWrapped from './ProductListWrapped';

interface Props {
  facetsConfiguration: FacetConfiguration[];
  categoriesConfiguration: EditorialCategoryConfiguration[];
}

interface DataSourceProps {
  items: Product[];
  category: string;
  facets: Facet[];
  previousCursor?: string;
  nextCursor?: string;
  total: number;
  totalItems: number;
  query: {
    categories?: string[];
    // TODO: other fields
  };
}

const filterMatchingVariants = (items: Product[]) => {
  return items.map((item) => ({
    ...item,
    variants: item.variants.filter((variant) => variant.isMatchingVariant !== false),
  }));
};

const YggdrasilPLPTastic = ({
  data,
  categories,
  params: { slug },
  ...props
}: TasticProps<DataSource<DataSourceProps> & Props & ProductListProps>) => {
  const searchQuery = props.searchParams.query;

  const flattenedCategories = categories.map((category) => flattenTree(category, 'descendants')).flat();

  const facetsConfiguration = buildFacetsConfiguration({
    facets: data.data?.dataSource?.facets ?? [],
    facetsConfiguration: data.facetsConfiguration,
    categories: flattenedCategories,
  });

  if (!data?.data?.dataSource) return <></>;

  const mainCategory = data.data.dataSource.query?.categories?.[0];
  const editorialContent =
    (mainCategory && data.categoriesConfiguration?.find((x) => x.category === mainCategory)?.content) || [];

  // Apply the filter to the items
  const filteredItems = filterMatchingVariants(data.data.dataSource.items);

  // Update the data object with filtered items
  const updatedData = {
    ...data,
    data: {
      ...data.data,
      dataSource: {
        ...data.data.dataSource,
        items: filteredItems,
      },
    },
  };

  return (
    <ProductListProvider
      uiState={{
        searchQuery,
        slug: slug?.at(-1),
        previousCursor: data.data.dataSource.previousCursor,
        nextCursor: data.data.dataSource.nextCursor,
        totalItems: data.data.dataSource.total,
      }}
      categories={flattenedCategories}
      facetsConfiguration={facetsConfiguration}
      pricesConfiguration={{}} //{pricesConfiguration}
      editorialContent={editorialContent}
      originalQuery={data.data.dataSource.query}
    >
      <ProductListWrapped products={updatedData.data.dataSource?.items ?? []} />
    </ProductListProvider>
  );
};
export default YggdrasilPLPTastic;
